import * as t from "io-ts";

export const BPGiftCardsConfiguration = t.type({
  Username: t.string,
  LegacyUsername: t.string,
  Password: t.string,
  LegacyPassword: t.string,
  ShopId: t.string,
  TillId: t.string,
  TerminalId: t.string,
  LegacyTerminalId: t.string,
  Currency: t.string,
});
